<template>
  <div class="boletos container-fluid d-flex flex-column mt-3">
    <span
      class="m-0 title"
      style="text-align: center; font-size: 25px"
      v-if="cobrancaPix && cobrancaPix.status === 'ATIVA'"
    >
      <b>Pix</b>
    </span>
    <main class="row h-100" v-if="!loading">
      <div
        class="col flex-column h-100 text-center p-4 d-flex"
        v-if="cobrancaPix && cobrancaPix.status === 'ATIVA'"
      >
        <div>
          <div class="px-5 pb-4">
            Escaneie o Qrcode ou copie a chave PIX para realizar o pagamento.
          </div>
          <div>
            <span
              class="container text-center px-3 px-lg-5"
              v-if="cobrancaPix != null && chavePix != null"
            >
              <img
                class="w-25 mt-5 mb-3"
                style="
                  min-width: 180px;
                  max-width: 270px;
                  margin-top: 0px !important;
                "
                v-bind:src="cobrancaPix.linkQrCode"
                alt="Cobrança Pix"
              />
              <br />
            </span>
          </div>
          <div @click="copiarChavePix" class="card p-2">
            <div v-if="copiaSucesso" class="sucesso">
              Chave pix copiada com sucesso
            </div>
            <strong class="border-bottom pb-2 mb-3">Pix Copia e Cola </strong>
            <div style="cursor: pointer" @click="copiarChavePix">
              <span></span>
              <img
                class=""
                style="max-width: 50px"
                src="../../assets/images/copiar.png"
                alt="Cobrança Pix"
              />
            </div>
            <input
              style="opacity: 0; height: 0"
              id="chavePix"
              :value="chavePix"
            />
          </div>
          <div class="my-3">
            <div class="d-flex justify-content-between">
              <span>Valor:</span
              ><strong
                >R$
                {{ formatPrice(cobrancaPix ? cobrancaPix.valor : 0) }}</strong
              >
            </div>
            <div class="d-flex justify-content-between">
              <span v-if="detailRecorrencia">Cobrança:</span
              ><strong>{{
                detailRecorrencia ? detailRecorrencia.periodicidadeTipo : ""
              }}</strong>
            </div>
          </div>
          <div class="card aviso px-3 d-block py-2 border-0" v-if="!erro">
            <div class="text-center">
              <b> Instruções para realizar o pagamento. </b>
              <br />
              <span v-if="detailRecorrencia"
                >Sua assinatura foi criada com sucesso e o pix para pagamento
                está disponível. Após o processamento do pagamento sua
                assinatura será ativada.</span
              >
              <br />
              <span>
                Copie a cole o código da chave pix no aplicativo do seu banco ou
                abra o aplicativo escolha pagar com QrCode e aponte a câmera
                para o QrCode.
              </span>
            </div>
          </div>
        </div>

        <div
          v-if="erro"
          class="card my-5 badge-danger text-center p-3 text-uppercase"
        >
          {{ erro.title }}
        </div>
      </div>
      <div v-else>
        <div class="card aviso px-3 d-block py-2 border-0">
          <div class="text-center">
            <b> Instruções para realizar o pagamento. </b>
            <br />
            <br />
            <span>
              Para finalizar o pedido selecione uma forma de pagamento e realize
              o pagamento.
            </span>
          </div>
        </div>
      </div>

      <div
        class="
          mt-3
          mb-5
          px-3
          col-12
          d-flex
          flex-column flex-lg-row
          justify-content-between
        "
      >
        <button
          class="btn btn_color_system px-5 mt-4 py-2"
          @click="$router.go(-1)"
          v-if="!tipo"
        >
          VOLTAR
        </button>

        <button
          :class="{ col: tipo }"
          class="btn btn_color_system mt-4 py-2"
          type="button"
          @click="alterarFormaPagamento()"
          v-if="tipo"
        >
          ALTERAR FORMA PAGAMENTO
        </button>
      </div>
    </main>
    <div class="row d-flex assinar-plano fixed-bottom text-center" v-if="plano">
      <div class="col-12 m-2 text-center">
        <small> <strong>Valor do plano</strong></small> <br />
        <span class="valor-plano"
          >R$ {{ formatPrice(plano.valorMensal) }} /{{
            plano.modeloCobranca.periodicidade
          }}</span
        >
        <br />
      </div>
    </div>
    <Loading v-if="loading"></Loading>
  </div>
</template>
<script>
import { APIService } from "../../APIService";
const apiService = new APIService();
import Loading from "@/components/Loading.vue";

export default {
  name: "StepPix",
  props: [
    "idAssinatura",
    "idPlanoAssinatura",
    "modeloCobranca",
    "tipo",
    "pedidoId",
  ],
  data() {
    return {
      loading: true,
      copiaSucesso: false,
      urlPdf: null,
      dataVencimento: null,
      erros: null,
      erro: null,
      detailRecorrencia: null,
      cobrancaPix: null,
      chavePix: null,
      cobrancaPixId: null,
      statusCobrancaPix: "ATIVA",
      destroy: false,
      planoId: null,
      assinaturaId: null,
      modeloCobrancaId: null,
      plano: this.$store.state.simulacaoPlano,
    };
  },
  components: {
    Loading,
  },
  mounted() {},
  created() {
    if (!this.idAssinatura) {
      this.planoId = this.$route.params.planoId;
    } else {
      this.planoId = this.idAssinatura;
    }

    if (!this.idPlanoAssinatura) {
      this.assinaturaId = this.$route.params.assinaturaId;
    } else {
      this.assinaturaId = this.idPlanoAssinatura;
    }

    if (!this.modeloCobranca) {
      this.modeloCobrancaId = this.$route.params.modeloCobrancaId;
    } else {
      this.modeloCobrancaId = this.modeloCobranca;
    }

    if (this.assinaturaId) {
      apiService
        .obterPixPagamentoRecorrente(this.assinaturaId)
        .then((res) => {
          this.cobrancaPix = res;
          this.chavePix = res.emv;
          this.btnloading = false;
          this.obterCobrancaPixCallback(res.id);
        })
        .catch((error) => {
          this.erro = error.response.data;
        })
        .finally(() => (this.loading = false));

      if (this.assinaturaId > 0) {
        apiService
          .obterMinhaAssinaturaID(this.assinaturaId)
          .then((response) => {
            this.detailRecorrencia = response;
          });
      } else {
        this.loading = false;
      }
    } else {
      if (this.tipo === "marketplace" && this.pedidoId) {
        this.obterCobrancaPorPedidoId(this.pedidoId);
      } else {
        this.obterCobrancaId(this.$route.params.cobrancaPixId);
      }
    }
  },
  beforeDestroy() {
    this.destroy = true;
  },
  methods: {
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    copiarChavePix() {
      document.getElementById("chavePix").select();
      document.execCommand("copy");
      this.copiaSucesso = true;
      setTimeout(() => {
        this.copiaSucesso = false;
      }, 800);
    },
    async goToStep(value) {
      if (value === "assinaturas" && !this.assinaturaId) {
        history.back();
      } else if (this.assinaturaId) {
        this.$router.push(`/assinaturas`);
        this.$emit("goToStep", value);
      } else if (value === "pedidos") {
        // setTimeout(() => {
        //   this.loading = true;
        // }, 100);

        setTimeout(() => {
          this.$router.push(
            `/${value}/${this.cobrancaPix.marketPlacePedidoId}`
          );
          this.loading = false;
        }, 5000);
      } else {
        history.back();
      }
    },
    obterCobrancaPixCallback(value) {
      apiService
        .obterCobrancaPixPorId(value)
        .then((res) => {
          let step = "";

          if (res.origem === "ASSINATURA") {
            step = "assinaturas";
          } else if (res.origem === "MARKETPLACE") {
            step = "pedidos";
          }

          if (res.status === "ATIVA" && this.destroy === false) {
            setTimeout(() => {
              //refaz a solicitacao
              this.obterCobrancaPixCallback(value);
            }, 2000);
          } else if (res.status === "CONCLUIDA") {
            this.statusCobrancaPix = "CONCLUIDA";

            this.pixConcluido(step);
          } else if (res.status === "CANCELADA") {
            this.loading = false;
          } else {
            this.loading = false;
            if (this.destroy !== true) {
              this.goToStep(step);
            }
          }
        })
        .catch((error) => {
          this.erro = error.response.data;
          this.loading = false;
        })
        .finally(() => (this.loading = false));
    },
    pixConcluido(step) {
      this.loading = true;
      this.$swal({
        title: "Parabéns!!!",
        text: "Pix realizado com sucesso!",
        confirmButtonText: "ok",
        preConfirm: () => this.goToStep(step),
      }).finally(() => (this.loading = false));
    },
    obterCobrancaId(cobrancaPixId) {
      apiService
        .obterCobrancaPixPorId(cobrancaPixId)
        .then((res) => {
          this.cobrancaPix = res;
          this.chavePix = res.emv;
          this.btnloading = false;
          this.obterCobrancaPixCallback(res.id);
        })
        .catch((error) => (this.erro = error.response.data))
        .finally(() => (this.loading = false));
    },
    obterCobrancaPorPedidoId(pedidoId) {
      apiService
        .obterCobrancaPixPorPedido(pedidoId, "ATIVA")
        .then((res) => {
          this.cobrancaPix = res;
          this.chavePix = res.emv;
          this.btnloading = false;
          this.obterCobrancaPixCallback(res.id);
        })
        .catch((error) => (this.erro = error.response.data))
        .finally(() => (this.loading = false));
    },
    alterarFormaPagamento() {
      if (this.tipo === "marketplace") {
        this.$router.push(`/carrinho/${this.pedidoId}`);
      }
    },
  },
};
</script>
<style scoped lang="scss">
.card {
  border-radius: 10px;
  position: relative;

  &.aviso {
    background-color: #dfdfdf;
  }

  .sucesso {
    background-color: #a0d405;
    color: #fff;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 10px;
    width: 100%;
    text-transform: uppercase;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
